"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$sendPushNotifToMe = exports.$getUsers = void 0;
var _qs = _interopRequireDefault(require("qs"));
var _oldHttpClient = require("../../apiClient/oldHttpClient");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var base = '/v5/users';
var $getUsers = _users => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "?").concat(_qs.default.stringify({
    ids: _users
  }))
});
exports.$getUsers = $getUsers;
var $sendPushNotifToMe = _ref => {
  var {
    title,
    message,
    sendAt,
    data,
    url
  } = _ref;
  return (0, _oldHttpClient.apiClient)({
    method: 'post',
    url: "".concat(base, "/push-notification"),
    body: {
      title,
      message,
      sendAt,
      data,
      url
    }
  });
};
exports.$sendPushNotifToMe = $sendPushNotifToMe;